<template>
    <div class="score-history">
        <span class="pic icon-avatar-sample"></span>
        <p class="name"> {{this.userName}} </p>
        <Loading :loadingState="ligaLoadingState" v-if="!hideSelector">
            <transition name="fade" appear>
                <select class="select" name="ligaSelected" v-model="ligaSelected">
                    <option :value="userLiga">{{ convertLigaIndexToString(userLiga) }}</option>
                    <option :value="'groups'">Grupe</option>
                    <option :value="liga.ligaId" v-for="liga of userLeauges" v-bind:key="liga.ligaId">
                        {{ liga.nazivLige || liga.ligaId }}
                    </option>
                </select>
                <template v-slot:error>Error Loading</template>
            </transition>
        </Loading>
        <ul class="cf">
            <li>
                <transition name="fade" appear>
                    <div v-if="!errors.prevRound">
                        <template v-if="prevRoundPoints && prevRoundPoints.loaded">
                            <p class="date">Prethodno kolo</p>
                            <p class="score">
                                <span>{{ prevRoundPoints.points }}</span>
                                <span>Bodova</span>
                            </p>
                            <p class="pos">
                                <span>{{ prevRoundPosition }}</span>
                                <span>Pozicija</span>
                            </p>
                        </template>
                        <template v-else>
                            <p class="message">Učitavanje rezultata</p>
                        </template>
                    </div>
                    <div v-if="errors.prevRound">
                        <p class="date">Prethodno kolo</p>
                        <p class="message">{{ errors.prevRound }}</p>
                    </div>
                </transition>
            </li>
            <li>
                <transition name="fade" appear>
                    <div v-if="!errors.month">
                        <template v-if="monthPoints && monthPoints.loaded">
                            <p class="date">{{ month }}</p>
                            <p class="score">
                                <span>{{ monthPoints.points }}</span>
                                <span>Bodova</span>
                            </p>
                            <p class="pos">
                                <span>{{ monthPosition }}</span>
                                <span>Pozicija</span>
                            </p>
                        </template>
                        <template v-else>
                            <p class="message">Učitavanje rezultata</p>
                        </template>
                    </div>
                    <div v-if="errors.month">
                        <p class="date">{{ month }}</p>
                        <p class="message">{{ errors.month }}</p>
                    </div>
                </transition>
            </li>
            <li>
                <transition name="fade" appear>
                    <div v-if="!errors.total">
                        <template v-if="totalPoints && totalPoints.loaded">
                            <p class="date">Ukupno</p>
                            <p class="score">
                                <span>{{ totalPoints.points }}</span>
                                <span>Bodova</span>
                            </p>
                            <p class="pos">
                                <span>{{ totalPosition }}</span>
                                <span>Pozicija</span>
                            </p>
                        </template>
                        <template v-else>
                            <p class="message">Učitavanje rezultata</p>
                        </template>
                    </div>
                    <div v-if="errors.total">
                        <p class="date">Ukupno</p>
                        <p class="message">{{ errors.total }}</p>
                    </div>
                </transition>
            </li>
        </ul>
    </div>
</template>

<script>
import { ResultType } from '../utils/ResultType'
import { TimeUtils } from '../utils/timeUtils'
import LoadingState from '../utils/loading/LoadingState'
import Loading from './common/Loading'
import { RoundUtils } from '../utils/roundUtils'
import { ApplicationState } from '../application-state'

export default {
    name: 'povijest-bodova',
    data: function () {
        return {
            ligaLoadingState: LoadingState.ON_HOLD,
            ligaSelected: this.userLiga,
            userLeauges: false,
            userName: null,
            errors: {
                prevRound: false,
                month: false,
                total: false
            }
        }
    },
    props: {
        value: [String, Number],
        hideSelector: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Loading
    },
    computed: {
        month () {
            return TimeUtils.getCurrentMonthLongName()
        },
        uid () {
            if (this.$route.params.uid) {
                return this.$route.params.uid
            }
            return this.$store.state.user.uid
        },
        prevRound () {
            return this.$store.state.prevRound
        },
        prevRoundPosition () {
            try {
                return this.$store.state.points.prevRound.position.toString().padStart(4, '0')
            } catch (error) { }
            return false
        },
        prevRoundPoints () {
            try {
                return this.$store.state.points.prevRound
            } catch (error) { }
            return false
        },
        monthPosition () {
            try {
                return this.$store.state.points.month.position.toString().padStart(4, '0')
            } catch (error) { }
            return false
        },
        monthPoints () {
            return this.$store.state.points.month
        },
        totalPosition () {
            try {
                return this.$store.state.points.total.position.toString().padStart(4, '0')
            } catch (error) { }
            return false
        },
        totalPoints () {
            return this.$store.state.points.total
        },
        userLiga () {
            try {
                return this.$store.state.metadata.userData.liga
            } catch (error) {
                return undefined
            }
        },
        appState () {
            return this.$store.state.appState
        }
    },

    mounted () {
        try {
            if (this.appState !== ApplicationState.LOADING_DATA) {
                this.initialLoadData()
            }
        } catch (error) {
            console.error(error)
        }
    },

    methods: {
        async initialLoadData () {
            try {
                this.getUsername()
            } catch (error) {
                console.error(error)
            }
            try {
                if (this.userLiga) {
                    this.ligaSelected = this.userLiga
                }
                this.ligaLoadingState = LoadingState.LOADING
                this.getUserLeauges()
            } catch (error) {
                this.ligaLoadingState = LoadingState.ERROR
            }
            try {
                await this.$db.results.getUserResultFor(ResultType.Round, this.prevRound.quizKey, this.uid)
            } catch (error) {
                this.errors.prevRound = error.message
            }
            try {
                const month = TimeUtils.getCurrentMonth()
                await this.$db.results.getUserResultFor(ResultType.Month, month, this.uid)
            } catch (error) {
                this.errors.month = error.message
            }
            try {
                await this.$db.results.getUserResultFor(ResultType.Total, undefined, this.uid)
            } catch (error) {
                this.errors.total = error.message
            }
        },

        async getUsername () {
            try {
                if (this.$route.params.uid) {
                    this.userName = await this.$db.metadata.getUsername(this.uid)
                } else {
                    this.userName = this.$store.state.metadata.userData.name
                }
            } catch (error) {
                this.userName = 'Nepoznati korisnik'
            }
        },

        checkUserDataLeaugeAndUserLeauges () {
            if (this.userLiga && this.userLeauges === false) {
                return true
            }
            return false
        },
        async getUserLeauges () {
            const data = await this.$db.lige.getAllMyLeaugeIds(this.uid)
            if (data) {
                this.userLeauges = {}
                for (let ligaId of data) {
                    this.userLeauges[ligaId] = {}
                    this.userLeauges[ligaId]['ligaId'] = ligaId
                    this.getLigaName(ligaId)
                }
            } else {
                this.userLeauges = []
            }
            this.ligaLoadingState = LoadingState.SUCCESS
        },
        convertLigaIndexToString (ligaIndex) {
            return RoundUtils.convertLigaIndexToString(ligaIndex)
        },
        async getLigaName (ligaId) {
            let data = await this.$db.lige.getLigaName(ligaId)
            this.userLeauges[ligaId]['nazivLige'] = data
            return data
        }
    },

    watch: {
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadData()
            }
        },

        ligaSelected (after) {
            this.$emit('input', after)
        },

        userLiga (after) {
            this.ligaSelected = after
        }
    }
}
</script>

<style lang="scss" scoped>
.score-history {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
    background-color: #fff;
    border-radius: 5px;
    padding: 54px 9px 9px;
    margin-top: 30px;

    .pic {
        display: block;
        position: absolute;
        left: calc(50% - 40px);
        top: -30px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 5px solid #fff;
        background-color: #fff;
        background-position: 50%;
        background-size: cover;
    }
    .name {
        font-family: "axiforma";
        font-size: 16px;
        letter-spacing: .3px;
        color: #000;
        margin-bottom: 10px;
    }
    ul {
        display: flex;
        margin-left: -6px;
        text-align: right;
        font-family: "axiforma";
        li {
            float: left;
            width: calc(100% / 3);
            padding-left: 6px;
            min-height: 150px;
        }
        li div {
            border-radius: 7px;
            background-color: #3d85ce;
            padding: 8px 10px;
            min-height: 150px;
            display: block;
            height: 100%;
            .message {
                color: white;
                text-align: left;
                line-height: 15px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 0;
                margin-top: 50%;
                transform: translateY(-50%);
            }
        }
        li:nth-child(2) div {
            background-color: #1e68b5;
        }
        li:nth-child(3) div {
            background-color: #10549b;
        }
    }
    .date {
        font-weight: 600;
        color: #fff;
        font-size: 12px;
        letter-spacing: .5px;
        margin-bottom: 34px;
        text-transform: capitalize;
    }
    .score {
        font-family: "mPlus";
        font-size: 18px;
        line-height: 20px;
        letter-spacing: -.2px;
        color: #fff;
        margin-bottom: 10px;

        span {
            display: block;
        }
        span:last-child {
            font-family: "axiforma";
            font-weight: 600;
            color: #78b7f5;
            text-transform: uppercase;
            font-size: 10px;
            letter-spacing: .5px;
        }
    }
    .pos {
        font-family: "axiforma";
        font-weight: 600;
        color: #78b7f5;
        text-transform: uppercase;
        font-size: 10px;
        letter-spacing: .5px;
        margin: 0;

        span {
            display: block;
        }
        span:first-child {
            display: inline-block;
            border-radius: 6px;
            min-width: 50px;
            text-align: center;
            color: #fff;
            font-weight: 800;
            letter-spacing: 1px;
            padding: 5px 3px;
            background-color: #08305d;
            margin-bottom: 6px;
        }
    }
}
.select {
    display: block;
    width: 100%;
    appearance: none;
    outline: none;
    text-align: left;
    font-family: "axiforma";
    font-size: 16px;
    line-height: 22px;
    letter-spacing: .3px;
    color: #000;
    border: none;
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 20px;
    padding-left: 4px;
    background: url(~@/assets/img/icons/icon-carrot.png) 98% 50% no-repeat;
    background-size: 6px;
}
</style>
